// extracted by mini-css-extract-plugin
export default {"donebtn":"form_donebtn__eHvde","txt":"form_txt__VdUzY"};